import { useI18n } from '../../contexts/I18nContext';

/**
 * Curated static emoji set — no npm picker dependency. Six small categories
 * (~120 emoji) cover the Discord-style reaction + composer use cases.
 */
const EMOJI_CATEGORIES: { key: string; emojis: string[] }[] = [
  {
    key: 'smileys',
    emojis: [
      '😀',
      '😃',
      '😄',
      '😁',
      '😆',
      '😅',
      '😂',
      '🤣',
      '🙂',
      '😉',
      '😊',
      '😍',
      '🥰',
      '😘',
      '😎',
      '🤩',
      '🥳',
      '😏',
      '😐',
      '😴',
      '🤔',
      '🤨',
      '😬',
      '🙄',
      '😮',
      '😢',
      '😭',
      '😤',
      '😡',
      '🤯',
      '😱',
      '🤗',
      '🤫',
      '🤭',
      '🫡',
      '😳',
      '😇',
      '🤓',
      '🥺',
      '😌',
    ],
  },
  {
    key: 'gestures',
    emojis: [
      '👍',
      '👎',
      '👏',
      '🙌',
      '🙏',
      '👌',
      '🤝',
      '✌️',
      '🤞',
      '🫶',
      '💪',
      '👋',
      '🤙',
      '👉',
      '👈',
      '☝️',
      '✋',
      '🖐️',
      '🤷',
      '🤦',
    ],
  },
  {
    key: 'hearts',
    emojis: [
      '❤️',
      '🧡',
      '💛',
      '💚',
      '💙',
      '💜',
      '🖤',
      '🤍',
      '💞',
      '💕',
      '💖',
      '💗',
      '💔',
      '❤️‍🔥',
      '💯',
      '💢',
      '💥',
      '✨',
      '⭐',
      '🌟',
    ],
  },
  {
    key: 'objects',
    emojis: [
      '🎉',
      '🎊',
      '🎁',
      '🏆',
      '🥇',
      '🔥',
      '🚀',
      '💡',
      '🔔',
      '📌',
      '📎',
      '📝',
      '📅',
      '⏰',
      '☕',
      '🍕',
      '🍰',
      '🍺',
      '🥂',
      '🎂',
    ],
  },
  {
    key: 'work',
    emojis: [
      '💻',
      '🖥️',
      '⌨️',
      '🖱️',
      '📱',
      '📞',
      '📧',
      '📊',
      '📈',
      '📉',
      '🗂️',
      '🗓️',
      '🔍',
      '🔧',
      '🔨',
      '⚙️',
      '🐛',
      '✅',
      '❌',
      '⚠️',
    ],
  },
  {
    key: 'nature',
    emojis: [
      '☀️',
      '🌙',
      '⛅',
      '🌧️',
      '❄️',
      '🌈',
      '🌸',
      '🌱',
      '🌍',
      '🐶',
      '🐱',
      '🦄',
      '🐢',
      '🦉',
      '🐝',
      '🍀',
      '🎄',
      '🌊',
      '⚡',
      '💧',
    ],
  },
];

/** Grid of curated emoji; render inside a Popover and call onPick per click. */
export function EmojiPicker({ onPick }: { onPick: (emoji: string) => void }) {
  const { t } = useI18n();
  return (
    <div
      className="max-h-64 overflow-y-auto p-2"
      role="listbox"
      aria-label={t('teamChat.addReaction')}
    >
      {EMOJI_CATEGORIES.map((category) => (
        <div key={category.key} className="mb-1">
          <div className="grid grid-cols-8">
            {category.emojis.map((emoji) => (
              <button
                key={emoji}
                type="button"
                onClick={() => onPick(emoji)}
                className="flex h-8 w-8 items-center justify-center rounded text-lg leading-none transition-colors hover:bg-accent"
              >
                {emoji}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
